export const getUrlWithoutTel = (url: string) => {
    return url.replace('tel:', '');
}